import { matchPath } from "react-router-dom";

const EXACT_ROUTES = [
  "/profile",
  "/services",
  "/archive",
  "/settings",
  "/logout",
  "/external-login",
  "/edit-profile",
  "/cart",
  "/checkout",
  "/upload-to-archive",
  "/invite-friends",
  "/upgrade",
  "/pricing",
  "/dashboard",
];

const DYNAMIC_ROUTES = [
  "/services/:id",
  "/questionnaire/*",
  "/sign-document/:documentId",
  "/requested-services/:id",
  "/requested-services/:id/completed",
  "/requested-services/:id/:questionnaireName",
  "/services/:id/requisites",
  "/pricing?*",
];

export function isValidAppRoute(path?: string): boolean {
  if (!path) {
    return false;
  }

  const hasExactMatch = EXACT_ROUTES.some((route) =>
    matchPath(path, {
      path: route,
      exact: true,
      strict: false,
    })
  );

  if (hasExactMatch) {
    return true;
  }

  return DYNAMIC_ROUTES.some((route) =>
    matchPath(path, {
      path: route,
      exact: false,
      strict: false,
    })
  );
}
